// translations/pages/teaching/en.js
export const teachingPageEN = {
  hero: {
    title: 'Edge-AI & EU AI Act Training',
    subtitle: 'Enterprise-AI Consulting • Edge Development • Legally Compliant Implementation'
  },
  intro: 'Specialized AI training for executives, project managers and development teams. From strategic consulting to technical implementation - EU AI Act compliant.',
  
  // New EU AI Act Section
  eu_ai_act: {
    title: 'EU AI Act Compliance & Edge Computing',
    subtitle: 'Legally secure AI implementation with local data processing',
    description: 'The EU AI Act defines strict rules for the use of artificial intelligence in Europe. Edge Computing offers the ideal solution: sensitive data remains local, compliance is simplified and control over AI systems stays in your hands.',
    benefits: [
      'Data protection through local processing',
      'Reduced compliance complexity',
      'Full control over AI decisions',
      'Transparency and traceability',
      'Minimized legal risks',
      'Independence from cloud providers'
    ],
    highlight: 'Edge Computing + EU AI Act = Legally secure AI without compromises'
  },
  
  offerings: {
    title: 'Course Offerings',
    categories: [
      {
        title: 'Artificial Intelligence & Machine Learning',
        icon: 'brain',
        topics: [
          'Generative AI & Large Language Models (Edge & Cloud)',
          'Classical Machine Learning (Edge-optimized)',
          'Deep Learning & Neural Networks (Edge Deployment)',
          'Computer Vision & NLP (Edge-capable Solutions)',
          'RAG Systems & LLM Fine-Tuning (Edge & Cloud)',
          'Autonomous AI Agents (Edge Computing)',
          'EU AI Act Compliance & Legal Certainty'
        ]
      },
      {
        title: 'Data Science & Statistics',
        icon: 'chart',
        topics: [
          'Descriptive & Inferential Statistics',
          'Data Modeling & Analysis',
          'Time Series Analysis',
          'Econometrics for Business/Economics',
          'Biostatistics for Natural Sciences',
          'A/B Testing & Experimental Design'
        ]
      },
      {
        title: 'Software Architecture & Security',
        icon: 'shield',
        topics: [
          'Modular Architectures',
          'Loose Coupling & Clean Code',
          'Microservices Design',
          'IT Security & Compliance',
          'DevOps & CI/CD',
          'Cloud Architectures'
        ]
      }
    ]
  },

  target_groups: {
    title: 'Target Groups',
    groups: [
      {
        title: 'Executive Leadership & Decision Makers',
        description: 'Strategic AI consulting, cost analysis and investment decisions',
        formats: ['Executive Briefings', 'ROI Analysis', 'Strategy Consulting'],
        focus: 'Business Cases, EU AI Act Compliance, Budget Planning'
      },
      {
        title: 'Project Managers & Leaders',
        description: 'AI project management, technology selection and implementation strategies',
        formats: ['Management Workshops', 'Technology Assessments', 'Roadmap Development'],
        focus: 'Project Planning, Vendor Selection, Risk Management'
      },
      {
        title: 'IT Developers & Engineers',
        description: 'Hands-on Edge-AI development, technical implementation and deployment',
        formats: ['Technical Deep Dives', 'Code Reviews', 'Architecture Workshops'],
        focus: 'Edge Computing, LLM Fine-Tuning, System Integration'
      },
      {
        title: 'Domain Specialists',
        description: 'AI understanding, prompting techniques and practical workplace application',
        formats: ['User Training', 'Prompting Workshops', 'Use Case Development'],
        focus: 'Practical Application, Workflow Integration, Productivity Enhancement'
      },
      {
        title: 'Students & Academics',
        description: 'University teaching, tutoring and academic project supervision',
        formats: ['Lectures', 'Tutoring', 'Thesis Supervision'],
        focus: 'Statistics, Econometrics, Research Methods'
      }
    ]
  },

  expertise: {
    title: 'Technical Expertise',
    items: [
      'Strategic AI roadmap development for enterprises',
      'Edge-AI systems with RAG/GRAG architectures and LoRA/QLoRA fine-tuning',
      'EU AI Act compliance strategies and legally secure implementation',
      'ROI analysis and investment planning for AI projects',
      'Autonomous AI agents with tool-sets and reasoning capabilities',
      'Change management for AI adoption in organizations',
      'Cloud and on-premise strategies (Azure, STACKIT)',
      'Prompting engineering and workflow optimization'
    ]
  },

  technologies: {
    title: 'Technology Stack',
    list: 'Python, R, PyTorch, TensorFlow, CUDA, Docker, React, Azure, STACKIT, JupyterLab, Google Colab, Hugging Face, SPSS, Stata'
  },

  clients: {
    title: 'Industries & Institutions',
    sectors: [
      'Health Insurance',
      'Publishing',
      'Banking & Fintech',
      'Industry & IoT',
      'Research & Universities',
      'Consulting',
      'Startups'
    ]
  },

  workshops: {
    title: 'Format Options',
    formats: [
      {
        title: 'Executive Briefing',
        duration: '2-4 Hours',
        description: 'Strategic overview for leadership with ROI focus and EU AI Act'
      },
      {
        title: 'Management Workshop',
        duration: '1-2 Days',
        description: 'Project manager training for AI implementation and change management'
      },
      {
        title: 'Technical Deep Dive',
        duration: '2-5 Days',
        description: 'Hands-on Edge-AI development for IT teams and engineers'
      },
      {
        title: 'User Training',
        duration: '0.5-1 Day',
        description: 'Practical AI application for domain specialists'
      },
      {
        title: 'Individual Coaching',
        duration: 'As needed',
        description: 'Personal support and project assistance'
      }
    ]
  },
  sidebar: {
    languagesLabel: 'Languages:',
    languagesValue: 'DE / EN / NL',
    focusLabel: 'Focus:',
    specializationTitle: 'Specialization',
    specializationItems: [
      'Edge AI for local data processing without cloud dependency',
      'EU AI Act compliant implementation for legal certainty'
    ],
    benefitsTitle: 'Benefits',
    benefits: [
      'Tailored to the target group',
      'Immediately applicable',
      'ROI-focused',
      'Remote or on-site'
    ]
  },
  cta: {
    title: 'Ready for strategic AI transformation?',
    description: 'From executive consulting to technical implementation - let\'s discuss your specific requirements.',
    button: 'Request consultation',
    email: 'info@paioneer.eu',
    subject: 'Training Inquiry'
  }
};
